import React, { useEffect, useState } from "react";
import customHttp from "../../services/customHTTP";
import { Box, CircularProgress, IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { AddCircle, ChevronLeft, ChevronRight, Delete } from "@mui/icons-material";
import Datagrid from "../Datagrid/Datagrid";
const ManageCustomersMaster = () => {
	const [allCustomers, setAllCustomers] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");

	useEffect(() => {
		const fetchAllCustomers = async () => {
			try {
				const response = await customHttp.get("/cus_sites/getcustomers");
				console.log(response.data.data);
				setAllCustomers(response.data.data);
			} catch (error) {
				setError(error.message);
			} finally {
				setLoading(false);
			}
		};
		fetchAllCustomers();
	}, []);

	const handleEdit = (site) => {
		console.log(site);
	};

	const columns = [
		{ field: "customer_number", headerName: "Customer Number", flex: 1 },
		{ field: "customer_name", headerName: "Customer Name", flex: 1 },
		// { field: "invoice_account", headerName: "Invoice Account", flex: 1 },
		// { field: "parent_customer", headerName: "Parent Customer", flex: 1 },
		{ field: "address_full_cus", headerName: "Customer Address", flex: 1 },
		{
			headerName: "Actions",
			sortable: false,
			width: 100, // Ensure there's enough space for icons
			headerAlign: "center",
			align: "left",
			renderCell: (params) => (
				<div>
					<Tooltip title="Edit Customer">
						<IconButton
							color="primary"
							aria-label="Edit Customer"
							onClick={(event) => {
								event.stopPropagation();
								handleEdit(params.row);
							}}>
							<EditIcon />
						</IconButton>
					</Tooltip>
				</div>
			),
		},
	];

	const customButtons = [
		{
			label: "Upload New Customers",
			icon: <AddCircle />,
			onClick: () => {
				console.log("Upload New Customers");
			},
		},
		{
			label: "Delete Selected",
			icon: <Delete />,
			onClick: () => {},
		},
	];

	if (loading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "40vh" }}>
				<CircularProgress />
			</Box>
		);
	}
	return (
		<div>
			<Datagrid
				loading={loading}
				data={allCustomers}
				columns={columns}
				customButtons={customButtons}
				checkboxSelection={true}
				rowIdField="cus_id"
				sortBy={[{ field: "cus_id", sort: "asc" }]}
			/>
		</div>
	);
};

export default ManageCustomersMaster;
